/**
 * Created by fers on 28.04.16.
 */

// import config from '../../common/config';

let variables;
// if (true || config.isProduction) {
    /* old puzzlette */
    variables =  {
        AUTH0_CLIENT_ID: 'kOJHQ26zVBSlyBPnVc8B6XHnQzy0AfR5',
        AUTH0_DOMAIN: 'auth0.dativery.com',
		BASE_URL: 'https://cdn.eu.auth0.com'
    };
// } else {
//     /* dativery DEV */
//     variables =  {
//         AUTH0_CLIENT_ID: 'EGalIGmCidAJaFLS99JybNdWoy8wWK4J',
//         AUTH0_DOMAIN: 'dativery.eu.auth0.com'
//     };
// }

export default variables;
